export const getPageTitle = ({ title }: { title?: string } = {}) => {
  return title ? `${title} / Reporting` : 'Reporting';
};
